import {Filters} from '@superweb/ui'
import type React from 'react'

import {useController} from './lib'
import type {BaseUIProps, Props} from './model'

const TariffFiltersBaseUI: React.FC<BaseUIProps> = props => {
  const {filters, label} = props

  return <Filters filters={filters} label={label} />
}

const TariffFilters: React.FC<Props> = props => {
  const baseUIProps = useController(props)

  return <TariffFiltersBaseUI {...baseUIProps} />
}

export {TariffFilters}
